import { jsx as _jsx } from "react/jsx-runtime";
import { resolveBlockBackgroundPalette } from "@diality/contracts";
import { Video } from "../components/blocks/video";
import { resolveSlotMedia } from "../render/slot-media";
/**
 * VideoBlock — the authorable form of the marketing Video band.
 *
 * It RENDERS the marketing component rather than restating its layout. The
 * design is finished; a second copy of a gradient-washed launch surface is a
 * copy that drifts, and the whole point of making this authorable is that an
 * Editor gets the band a visitor already gets.
 *
 * IT NARROWS ON THE KIND before handing anything over. A reference that lost
 * `mediaType` resolves to the SAME address with no still, so `videoSrc` would be
 * right and `posterSrc` empty — and a `<video src>` pointed at a picture is a
 * silent wrong-kind failure that shows a visitor a blank box. `validateVideo`
 * refuses to store such a reference; this refuses to render one.
 */
export function VideoBlock({ data }) {
    const { playLabel, media } = data;
    const film = media?.mediaType === "video" ? media : null;
    return (_jsx(Video, { backgroundPalette: data.backgroundPalette, videoSrc: film?.url, posterSrc: film?.poster, 
        // `undefined`, not `""`, so a half-written draft on the canvas falls back
        // to the component's own default rather than offering a control with no
        // name at all. An Editor cannot SAVE one — that is `validateVideo`'s rule
        // — but they can be part-way through typing one.
        playLabel: playLabel || undefined }));
}
export function videoFromBlock(block, resolve) {
    const scalars = block.scalars ?? {};
    return {
        backgroundPalette: resolveBlockBackgroundPalette(scalars.backgroundPalette),
        playLabel: scalars.playLabel?.trim() ?? "",
        // Through the shared slot resolver rather than `resolve` directly, so this
        // block reads its slot the one way every block reads one.
        media: resolveSlotMedia(block, "media", resolve),
    };
}
export const videoBlockEntry = {
    Component: VideoBlock,
    fromBlock: videoFromBlock,
};
//# sourceMappingURL=video.js.map